module.exports = __webpack_public_path__ + "8953028aa2566f041fdfa883db33be34.png";